module.exports = __webpack_public_path__ + "img/museum_store.6330ff9d.svg";